module.exports = __webpack_public_path__ + "media/images/country_flags/kh-3c4c9dc1102a0656ed0b489711547d5e.png";